import Api from '..';

// =============================================================================
// SERVICE: MANUTENÇÃO DE CARRINHOS — Responsáveis
// Delegado para o módulo genérico de arranjos.
// =============================================================================

const ManutencaoCarrinhosService = {

  listarResponsaveis: async () => {
    const response = await Api.get('/arranjos/manutencao-carrinhos/responsaveis');
    return response.data;
  },

  obterPrincipal: async () => {
    const response = await Api.get('/arranjos/manutencao-carrinhos/responsaveis/principal');
    return response.data;
  },

  adicionarResponsavel: async (usuarioId) => {
    const response = await Api.post('/arranjos/manutencao-carrinhos/responsaveis', { usuarioId });
    return response.data;
  },

  definirPrincipal: async (id) => {
    const response = await Api.patch(`/arranjos/manutencao-carrinhos/responsaveis/${id}/principal`);
    return response.data;
  },

  removerResponsavel: async (id) => {
    const response = await Api.delete(`/arranjos/manutencao-carrinhos/responsaveis/${id}`);
    return response.data;
  },
};

export default ManutencaoCarrinhosService;
